// THIS FILE IS AUTOGENERATED: DO NOT MODIFY!!!
import Entry0 from './logs/2017-07-27_Test.md';
import Entry1 from './logs/2017-08-08_Test.md';
import Entry2 from './logs/2017-09-05_Test.md';
import Entry3 from './logs/2017-10-03_Test.md';
import Entry4 from './logs/2017-11-14_Test.md';
import Entry5 from './logs/2018-03-07_Test.md';
import Entry6 from './logs/2018-03-20_Test.md';
import Entry7 from './logs/2018-05-16_Test.md';
import Entry8 from './logs/2018-09-18_Test.md';

export default [Entry0,Entry1,Entry2,Entry3,Entry4,Entry5,Entry6,Entry7,Entry8];


// WEBPACK FOOTER //
// ./src/changelog/index.js